import { environment } from 'src/environments/environment';
import { Theme } from './symbols';

import(`./${environment.theme}-theme`).then(res => {
    const app_theme: Theme = res.theme;
    // Apply current system color identity
    theme.properties['--background'] = app_theme.properties['--background'];
});

export const theme: Theme = {
    name: 'dark',
    properties: {
        '--background': '#37415a',
        '--bg-primary': '#222',
        '--bg-page': '#444',
        '--on-background': '#fff',
        '--form-label-text': '#eee',

        '--primary': '#333',
        '--on-primary': '#00000013',
        '--secondary': '#444',
        '--on-secondary': '#fff',
        '--color-primary': '#fff',
        '--on-color-primary': '#fff',
        '--color-secondary': '#eee',
        '--on-color-secondary': '#fff',

        '--invert': 0.8,
    },
};

export const darkTheme: Theme = theme;
